<script lang="ts">
import { useCtaComponent } from '@monogrid/vue-boost/core'
import { templateRef } from '@vueuse/core'
import gsap from 'gsap'
import { computed, defineComponent, PropType } from 'vue'

import IconComponent, { icons } from '@/components/atoms/IconComponent.vue'

export default defineComponent({
  name: 'CtaSecondary',
  components: {
    IconComponent
  },
  props: {
    iconStart: { type: String as PropType<keyof typeof icons>, default: undefined },
    iconEnd: { type: String as PropType<keyof typeof icons>, default: undefined },
    monospace: { type: Boolean, default: false },
    underline: { type: Boolean, default: false },
    scrambled: { type: Boolean, default: false }
  },
  setup (props, context) {
    const { bindings, component } = useCtaComponent(context)
    const elLabel = templateRef('elLabel')
    const text = computed(() => elLabel.value?.textContent)

    function onMouseEnter () {
      if (!props.scrambled) return

      gsap.to(elLabel.value, {
        scrambleText: {
          text: text.value,
          chars: text.value,
          tweenLength: true
        },
        duration: 1,
        ease: 'none'
      })
    }

    return {
      bindings,
      component,
      onMouseEnter
    }
  }
})
</script>

<template>
  <component
    :is="component"
    v-bind="bindings"
    class="cta-secondary inline-flex items-center gap-2"
    @mouseenter="onMouseEnter"
  >
    <slot name="icon-start">
      <IconComponent v-if="iconStart" class="icon" :icon="iconStart" />
    </slot>
    <span
      ref="elLabel"
      class="whitespace-nowrap"
      :class="{
        'label1 uppercase': monospace,
        underline,
        'pointer-events-none': scrambled
      }"
    >
      <slot />
    </span>
    <slot name="icon-end">
      <IconComponent v-if="iconEnd" class="icon" :icon="iconEnd" />
    </slot>
  </component>
</template>

<style lang="scss" scoped>
.cta-secondary {
  color: inherit;
  line-height: inherit;
}

.icon {
  width: rem(12px);
  height: rem(12px);
  color: color('green');
}
</style>
